var map = {
	"./CertificateSection/Cert_FSPCA-FSVP_en.jpg": 5274,
	"./CertificateSection/Cert_FSPCA-PCQI_en.jpg": 8708,
	"./CertificateSection/Cert_ServSafe-ch.jpg": 8588,
	"./CertificateSection/Cert_ServSafe-en.jpg": 1740,
	"./CertificateSection/Quality_section.jpg": 1179,
	"./CertificateSection/system/Cert_FSSC22000_ch.jpg": 3908,
	"./CertificateSection/system/Cert_FSSC22000_en.jpg": 3860,
	"./CertificateSection/system/Cert_HACCP_ch.jpg": 8964,
	"./CertificateSection/system/Cert_HACCP_en.jpg": 4900,
	"./CertificateSection/system/Cert_HALAL.jpg": 2201,
	"./CertificateSection/system/Cert_ISO22000_ch.jpg": 5100,
	"./CertificateSection/system/Cert_ISO22000_en.jpg": 1404,
	"./CertificateSection/system/Cert_co2report.jpg": 5211,
	"./CertificateSection/system/Cert_operator.jpg": 3853,
	"./DigitalSection/Digital_1.jpg": 6119,
	"./DigitalSection/Digital_2.jpg": 9624,
	"./DigitalSection/Digital_3.jpg": 4453,
	"./DigitalSection/Digital_4.jpg": 7390,
	"./DigitalSection/Digital_section.jpg": 3031,
	"./NewsPage/News_20260213.jpg": 3650,
	"./OrporateSection/Orporate_1.jpg": 287,
	"./OrporateSection/Orporate_2.jpg": 4291,
	"./OrporateSection/Orporate_3.jpg": 5901,
	"./OrporateSection/Orporate_4.jpg": 4438,
	"./ProductJourneySection/Icon_1.svg": 7401,
	"./ProductJourneySection/Icon_2.svg": 3002,
	"./ProductJourneySection/Icon_3.svg": 843,
	"./ProductJourneySection/Icon_4.svg": 7780,
	"./ProductJourneySection/Icon_5.svg": 3413,
	"./ProductJourneySection/Icon_6.svg": 2166,
	"./ProductJourneySection/flow_1.jpg": 80,
	"./ProductJourneySection/flow_2.jpg": 3695,
	"./ProductJourneySection/flow_3.jpg": 1314,
	"./ProductJourneySection/flow_4.jpg": 6801,
	"./ProductJourneySection/flow_5.jpg": 8756,
	"./ProductJourneySection/flow_6.jpg": 2915,
	"./about-hero.jpg": 6475,
	"./advantage-hero.jpg": 9099,
	"./contect-hero.jpg": 1670,
	"./home-hero.jpg": 1313,
	"./logo.png": 678,
	"./news-hero.jpg": 6001,
	"./product_1.jpg": 7814,
	"./product_2.jpg": 17,
	"./product_3.jpg": 8212,
	"./product_4.jpg": 6495,
	"./product_5.jpg": 4786,
	"./taiwan-map.png": 6610,
	"./world-map.png": 9026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;